export default __webpack_public_path__ + "static/media/allAds.94f67582.svg";